import React from 'react';
import { FaEnvelope } from 'react-icons/fa';
import jinitImg from '../images/team/jinit.jpeg';
import meetImg from '../images/team/meet.jpeg';
import anshImg from '../images/team/ansh.jpg';
import { AiFillInstagram } from 'react-icons/ai';
import { IoLogoWhatsapp } from 'react-icons/io';

const TeamSection = () => {
  const team = [
    {
      name: 'Jinit Mungra',
      position: 'Founder & CEO',
      image: jinitImg,
      bio: 'Visionary leader with expertise in digital marketing and business strategy. Passionate about driving growth and innovation in the digital space.',
      socialLinks: {
        instagram: 'https://www.instagram.com/jinit_patel246?igsh=MW5uYXM1azg3dHhqdg==',
        whatsapp: 'https://wa.me/+919898180531',
        email: 'jinitmungra595@gmail.com',
      },
    },
    {
      name: 'Meet Desai',
      position: 'CTO & Co-Founder',
      image: meetImg,
      bio: 'Technology expert specializing in web development, AI, and digital transformation. Committed to building scalable and innovative solutions.',
      socialLinks: {
        instagram: 'https://www.instagram.com/meet_desai_005?igsh=MTNiNnJ1YzRjYWFodg==',
        whatsapp: 'https://wa.me/+919033552033',
        email: 'meetd3783@gmail.com',
      },
    },
    {
      name: 'Ansh Kared',
      position: 'COO & Co-Founder',
      image: anshImg,
      bio: 'Operations specialist focused on scaling businesses and optimizing processes. Dedicated to operational excellence and team development.',
      socialLinks: {
        instagram: 'https://www.instagram.com/_.ansh._2312?igsh=MWJyN2tlc2YwNWZpNw==',
        whatsapp: 'https://wa.me/+918849589594',
        email: 'anshkared90@gmial.com',
      },
    },
  ];

  return (
    <section className="team-section" id="team">
      <div className="container">
        <div className="section-header">
          <span className="subtitle">Our Team</span>
          <h2>Meet the Founders</h2>
          <p>The passionate individuals behind GrowthVibe's success, bringing together diverse expertise to drive innovation and growth.</p>
        </div>
        <div className="row justify-content-center">
          {team.map((member, index) => (
            <div key={index} className="col-lg-4 col-md-6">
              <div className="team-member">
                <div className="team-member-image">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>
                <div className="team-member-content">
                  <div>
                    <h3>{member.name}</h3>
                    <span className="position">{member.position}</span>
                    <p>{member.bio}</p>
                  </div>
                  <div className="social-links">
                    <a
                      href={member.socialLinks.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`${member.name}'s Instagram`}
                      style={{ color: '#3A7BD5', fontSize: '18px', cursor: 'pointer' }}
                    >
                      <AiFillInstagram />
                    </a>
                    <a
                      href={member.socialLinks.whatsapp}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`${member.name}'s Whatsapp`}
                      style={{ color: '#3A7BD5', fontSize: '18px', cursor: 'pointer' }}
                    >
                      <IoLogoWhatsapp />
                    </a>
                    <a
                      href={`mailto:${member.socialLinks.email}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`${member.name}'s email`}
                    >
                      <FaEnvelope />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
